import CardLoyalty from './card-loyalty.vue';

export default CardLoyalty;
